/**
 * Checks whether a given date string is in the past (expired).
 */
export function isDateExpired(dateStr: string): boolean {
  return new Date() > new Date(dateStr);
}

/**
 * Formats a date string to use '/' as the separator (MM/DD/YYYY).
 * Replaces all common separators: '-', '.', ' ', ',', '\', '|'
 */
export function formatDate(dateStr: string): string {
  // Normalize all common date separators to '/'
  return dateStr.replace(/[-.\s,\\|]+/g, '/');
}

/**
 * Parses any recognisable date string and returns it as MM/DD/YYYY.
 * Handles ISO (YYYY-MM-DD), slash-separated, and dot-separated formats.
 * Returns the original string unchanged if parsing fails.
 */
export function formatDateMMDDYYYY(dateStr: string): string {
  if (!dateStr) return '';

  // Normalise separators to '-' for consistent parsing
  const normalised = dateStr.trim().replace(/[./\s,\\|]+/g, '-');
  const parts = normalised.split('-');

  if (parts.length !== 3) return dateStr;

  const [a, b, c] = parts;

  let month: string, day: string, year: string;

  // Detect YYYY-MM-DD (ISO) — first part is 4-digit year
  if (a.length === 4) {
    year = a;
    month = b;
    day = c;
  } else {
    // Assume MM-DD-YYYY or DD-MM-YYYY — treat as MM/DD/YYYY input
    month = a;
    day = b;
    year = c;
  }

  // Zero-pad month and day
  const mm = month.padStart(2, '0');
  const dd = day.padStart(2, '0');

  return `${mm}/${dd}/${year}`;
}
